import { render, staticRenderFns } from "./boolean.vue?vue&type=template&id=664a1488&scoped=true&"
import script from "./boolean.vue?vue&type=script&lang=js&"
export * from "./boolean.vue?vue&type=script&lang=js&"
import style0 from "./boolean.vue?vue&type=style&index=0&id=664a1488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a1488",
  null
  
)

export default component.exports